var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarPlaceholderSecondary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1080,
    viewBox: "124 40 840 840",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#6dc9a7",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080,
    transform: "translate(540 540)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(540 540)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#cbebdf",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#cbebdf",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(4.22 0 0 4.22 -.16 -.16)",
    d: "M128 10C62.8 10 10 62.8 10 128s52.8 118 118 118 118-52.8 118-118S193.2 10 128 10zm.8 232.8c-34.9 0-66.1-15.7-87-40.3 3.8-29.4 26.4-53.7 57-63.3-12.7-10.3-21-27.1-21-46.1 0-31.2 22.3-56.5 49.8-56.5 27.5 0 49.8 25.3 49.8 56.5 0 19-8.3 35.9-21 46.1 31.4 9.8 54.4 35.3 57.3 65.7-20.8 23.3-51.2 37.9-84.9 37.9z",
    strokeLinecap: "round"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholderSecondary);
export default __webpack_public_path__ + "static/media/avatarPlaceholderSecondary.a678882d747dc640ca0724a54d308c1b.svg";
export { ForwardRef as ReactComponent };